"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/ValueAddedSolutions/assembly/assembly-methods-for-parts";

const METHODS = [
	{ keyPrefix: "methodsCard1", image: `${IMAGE_BASE}/manual-assembly.webp` },
	{ keyPrefix: "methodsCard2", image: `${IMAGE_BASE}/molding-assembly.webp` },
	{ keyPrefix: "methodsCard3", image: `${IMAGE_BASE}/mechanical-assembly.webp` },
	{ keyPrefix: "methodsCard4", image: `${IMAGE_BASE}/adhesive-assembly.webp` },
] as const;

export default function AssemblyMethods() {
	const t = useTranslations("new-assembly");

	return (
		<section className="bg-[#f6f6f6] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="inline-block text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						<span className="block">{t("methodsTitleLine1")}</span>
						<span className="mt-1 flex items-end gap-4">
							<span>{t("methodsTitleLine2")}</span>
							<span className="mb-1 h-[3px] w-20 bg-themePrimary400 sm:w-28 md:w-36" aria-hidden="true" />
						</span>
					</h2>
					<p className="mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">{t("methodsDesc")}</p>
				</header>

				<div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
					{METHODS.map((method) => (
						<article key={method.keyPrefix} className="group flex h-full flex-col bg-[#eeeeee]">
							<div className="relative aspect-[4/3] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={method.image}
									alt={t(`${method.keyPrefix}ImageAlt`)}
									fill
									className="object-cover transition-transform duration-300 group-hover:scale-105"
									sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
								/>
							</div>
							<div className="flex flex-1 flex-col p-5 sm:p-6">
								<h3 className="mb-3 text-lg font-bold leading-tight text-black sm:text-xl md:text-2xl lg:text-nowrap">
									{t(`${method.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">
									{t(`${method.keyPrefix}Desc`)}
								</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
